import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const CandidateActionsWrapper = styled.div`
  color: #333;
  display: flex;
  flex: 1;
  position: relative;
  ${(props) =>
    props.focused &&
    `
      padding-bottom: 4.12rem;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d2d2d2;
  padding: 0 0 5px 0;
  font-weight: 600;
`;

export const MessageFormWrapper = styled.div`
  position: fixed;
  bottom: 15px;
  width: 650px;
  border-top: 10px solid #e4e5e7;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${mediaMaxWidth.tablet`
    width: 95vw;
  `}
`;

export const Form = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;

  .submit-action {
    button {
      margin-top: 0;
      position: absolute;
      right: 20px;
      border: none;
      background: #fff;
      color: #79D9D9;
      width: 40px;
      padding: 5px 0;
      min-width: unset;
      bottom: 14px;
      font-size: 1.5em;

      &:after {
        content: "\f1d8";
        font-family: FontAwesome;
      }

      &:hover {
        color: #402680;
        border: none;
        background: #fff;
      }

      &:focus {
        outline: none;
        background: transparent;
        border: 1px solid transparent;
      }

      &[data-disabled="true"] {
        border: 1px solid grey;
        background: transparent;
        color: grey;
      }
    }
  }

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 11px 10px 4px 10px;
`;

export const Bottom = styled.div`
  ${(props) => props.marginTop && "margin-top: 15px;"}
`;

export const ActionsButton = styled.div`
  display: flex;
  text-align: left;
  font-weight: 700;
  width: 160px;
  height: 22px;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #402680;
  }

  svg {
    position: relative;
    left: 6px;
    top: 3px;
  }

  ${mediaMaxWidth.phone`
    width: 140px;
    font-size: 0.9em;
    align-items: center;

    svg {
      top: 0;
    }
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.75em;
  `}
`;

export const ActionsList = styled.div`
  position: absolute;
  bottom: 102px;
  background: #fff;
  width: 300px;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 5px #d6d6d6;
  opacity: 0;
  transition: 0.15s ease-in-out;
  left: -300px;
  padding: 10px;
  pointer-events: none;

  &::after,
  &::before {
    top: 100%;
    left: 52px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: #e8e8e8;
    border-width: 10px;
    margin-left: -2px;
  }

  &.shown {
    left: 10px;
    bottom: 100px;
    opacity: 1;
    z-index: 1;
    pointer-events: auto;
  }

  ${mediaMaxWidth.phone`
    width: 250px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 220px;
  `}
`;

export const StyledOption = styled.input`
  margin: 2px 0;
  display: none;
`;

StyledOption.displayName = "StyledOption";

export const StyledLabel = styled.label`
  display: block;
  font-weight: 500;
  margin: 0px 0;
  padding: 7px 10px;
  cursor: pointer;
  transition: 0.05s ease-in-out;

  &:hover {
    background: #79D9D9;
    color: #fff;
    border-radius: 4px;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.9em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.8em;
  `}
`;

StyledLabel.displayName = "StyledLabel";

export const ActionsListReduced = styled.div`
  position: absolute;
  background: #fff;
  bottom: 100px;
  width: 200px;
  text-align: left;
  border-radius: 4px;
  box-shadow: 0 0 5px #d6d6d6;
  opacity: 0;
  transition: 0.15s ease-in-out;
  left: -300px;
  padding: 10px;
  pointer-events: none;

  &::after,
  &::before {
    top: 100%;
    left: 52px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #fff;
    border-width: 8px;
    margin-left: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: #e8e8e8;
    border-width: 10px;
    margin-left: -2px;
  }

  &.shown {
    left: 10px;
    bottom: 100px;
    opacity: 1;
    z-index: 1;
    pointer-events: auto;

    ${mediaMaxWidth.phone`
      left: 0;
    `}
  }
`;

export const SelectedAction = styled.div`
  margin: 0.25rem 0;
  border: 1px solid;
  border-radius: 4px;
  text-transform: capitalize;
  font-size: 0.85em;
  font-weight: 700;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: table;
  border-radius: 4px;
  padding: 4px 25px;
  position: relative;
  z-index: 1;
  min-width: 180px;
  display: ${(props) => (props.active ? null : "none")};

  ${mediaMaxWidth.phone`
    padding: 5px 15px 5px 5px;
    font-size: 0.77em;
    min-width: 140px;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.7em;
    min-width: 125px;
  `}

  &::before {
    content: "•";
    color: #333;
    font-size: 3.1em;
    position: absolute;
    top: -17px;
    left: 5px;
    height: 5px;

    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const RemoveAction = styled.span`
  padding: 0 0 0 10px;
  cursor: pointer;

  &::after {
    content: "✖";
    font-size: 1.37em;
    position: absolute;
    font-weight: 700;
    top: 0px;
    right: 7px;
    transition: 0.1s ease-in-out;

    ${mediaMaxWidth.phone`
      top: 2px;
    `}
  }

  &:hover {
    &::after {
      color: #79D9D9;
    }
  }
`;

export const AttachmentPopupTrigger = styled.div`
  position: absolute;
  right: 70px;
  bottom: 9px;
  cursor: pointer;
  font-size: 1.8em;
  transform: rotate(82deg);
  color: #8a8a8a;
  z-index: ${(props) => props.textareaFocused && "2"};

  &:after {
    content: "\f0c6";
    font-family: FontAwesome;
  }

  &:hover {
    color: #402680;
  }
`;

export const AttachmentPopup = styled.div`
  position: absolute;
  right: 10px;
  width: 350px;
  border-radius: 4px;
  background: #fff;
  bottom: 58px;
  z-index: 1;
  height: 90px;
  box-shadow: 0 0 5px #d6d6d6;
  bottom: ${(props) => (props.active ? "58px" : "20px")};
  opacity: ${(props) => (props.active ? "1" : "0")};
  pointer-events: ${(props) => (props.active ? "initial" : "none")};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.12s ease-in-out;

  &::after,
  &::before {
    top: 100%;
    right: 63px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-top-color: #fff;
    border-width: 8px;
    margin-right: 0px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-top-color: #e8e8e8;
    border-width: 10px;
    margin-right: -2px;
  }

  ${mediaMaxWidth.phone`
    height: 100px;
    width: 270px;
  `}
`;

export const AttachmentCounter = styled.div`
  &::after {
    content: "1";
    background: #79D9D9;
    color: #fff;
    position: absolute;
    right: 69px;
    bottom: 15px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8em;
    font-weight: 700;
    font-family: sans-serif;
    pointer-events: none;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 7px;
  top: 2px;
  font-size: 1.2em;
  color: #79D9D9;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &::after {
    content: "\f00d";
    font-family: FontAwesome;
  }

  &:hover {
    color: #402680;
  }
`;

export const TextAreaWrapper = styled.div`
  height: 3rem;
  margin: 0.5rem 0.56rem;
  ${(props) =>
    props.focused &&
    `
    margin: 0;
    height: auto;
    width: auto;
    position: absolute;
    top: 0.5rem;
    bottom: 0.5rem;
    left: 0.5em;
    right: 0.5rem;
    z-index: 1;
  `}
`;

export const TextArea = styled.textarea`
  border: ${(props) =>
    props.disabled ? "1px solid grey" : "2px solid #e7e7e7"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  padding: 10px 100px 10px 10px;
  height: 100%;
  background: ${(props) => props.disabled && "#e4e5e7"};

  &:focus {
    border-color: #79D9D9;
    outline: none;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const SendButton = styled.input`
  background: none;
  border: none;
  color: #79D9D9;
  font-weight: 700;
  transition: 0.2s ease-in-out;

  &:focus {
    outline: none;
  }

  &:focus,
  &:hover {
    color: #402680;
  }
`;

export const NotePopup = styled.div`
  position: absolute;
  bottom: 218px;
  font-size: 0.9em;
  background-color: #e6e6e6;
  padding: 15px 20px;
  border-radius: 8px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 540px;
  box-shadow: 0 0 10px #b4b3b3;
  line-height: 1.7em;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  ${mediaMaxWidth.tablet`
    width: calc(100% - 40px);
    font-size: 0.8em;
    padding: 10px 10px;
  `}
`;

export const Note = styled.div`
  position: absolute;
  top: -2px;
  right: 11px;
  font-size: 0.9em;
  font-style: italic;
`;

export const Asterisk = styled.div`
  display: inline;
  font-size: 2em;
  top: 12px;
  left: -3px;
  position: relative;
`;

export const PlaceholderBtn = styled.div`
  position: absolute;
  right: 28px;
  bottom: 12px;
  color: #9c9c9c;
  font-size: 1.52em;
  cursor: not-allowed;
  z-index: 1;

  &:after {
    content: "\f1d8";
    font-family: FontAwesome;
  }
`;

export const FinalSalaryTooltip = styled.div`
  position: absolute;
  bottom: 135px;
  font-size: 0.9em;
  background-color: #e6e6e6;
  padding: 15px 20px;
  border-radius: 8px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 330px;
  box-shadow: 0 0 10px #b4b3b3;
  line-height: 1.7em;
  text-align: center;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  ${mediaMaxWidth.phone`
    width: calc(100% - 40px);
    font-size: 0.8em;
    padding: 10px 10px;
  `}
`;

export const FinalSalaryLabel = styled.label`
  position: absolute;
  right: 170px;
  top: 12px;

  ${mediaMaxWidth.phone`
    display: none;
  `}
`;

export const FinalSalaryInput = styled.input`
  position: absolute;
  right: 10px;
  top: 7px;
  width: 150px;
  height: 30px;
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  padding: 0 10px;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const RejectionReason = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid #e7e7e7;
  width: 100%;
`;

export const RejectionReasonLabel = styled.label`
  display: block;
  color: #333;
  font-size: 0.9em;
  margin-bottom: 5px;
  font-weight: 600;
  position: relative;
  display: inline-flex;
`;

export const RejectionReasonSelect = styled.select`
  background-color: #fff;
  border: 2px solid #e7e7e7;
  height: 40px;
  width: 100%;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 0.9em;

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }
`;

export const SubReasonsContainer = styled.div`
  padding: 10px 20px 0;
`;

export const SubReasonsLabel = styled.label`
  display: block;
  color: #333;
  font-size: 0.9em;
  margin-bottom: 10px;
  font-weight: 600;
`;

export const CheckBoxesGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;

  ${mediaMaxWidth.phone`
    flex-flow: unset;
    flex-direction: column;
  `}
`;

export const CheckBoxesGroupItem = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 5px 0 10px 0;

  ${mediaMaxWidth.phone`
    width: 100%;
  `}
`;

export const CheckBoxLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin-bottom: 0px;
  cursor: pointer;
  font-weight: 400;
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ .indicator {
    background: #79D9D9;
    border: 2px solid #79D9D9;

    &:after {
      display: block;
    }
  }
`;

export const Indicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #402680;
  }
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.5em;
  position: absolute;
  top: -5px;
  right: -15px;
  color: #79D9D9;
`;
